import { useTranslation } from 'react-i18next';
import { mergeClasses } from '@fluentui/react-components';
import { WidgetContainer } from '../WidgetContainer';
import { StarRating } from '../StarRating';
import { getCSATColor } from '../utils/csatColors';
import { useCSATSiteCardsStyles } from './CSATSiteCards.styles';
import type { SurveySiteCSAT } from '@/types/reports';
import { tokens } from '@fluentui/react-components';

export interface CSATSiteCardsProps {
  data: SurveySiteCSAT[];
  titleKey: string;
}

export function CSATSiteCards({ data, titleKey }: CSATSiteCardsProps) {
  const styles = useCSATSiteCardsStyles();
  const { t } = useTranslation('reports');

  function getAccentClass(score: number): string {
    const color = getCSATColor(score);
    if (color === tokens.colorPaletteGreenForeground1) return styles.accentGreen;
    if (color === tokens.colorPaletteMarigoldForeground2) return styles.accentAmber;
    return styles.accentRed;
  }

  return (
    <WidgetContainer title={t(titleKey)}>
      <div className={styles.root} role="list">
        {data.map((site) => (
          <div
            key={site.siteName}
            className={mergeClasses(styles.card, getAccentClass(site.csatScore))}
            role="listitem"
            aria-label={`${site.siteName}: ${site.csatScore} out of 5, ${site.responseCount} responses`}
          >
            <span className={styles.siteName}>{site.siteName}</span>
            <span className={styles.score}>{site.csatScore.toFixed(1)}</span>
            <StarRating value={site.csatScore} />
            <span className={styles.meta}>{site.responseCount} responses</span>
            <span className={styles.meta}>{Math.min(site.responseRate, 100)}% response rate</span>
          </div>
        ))}
      </div>
    </WidgetContainer>
  );
}
